module.exports = __webpack_public_path__ + "static/img/BASIL-HART.fdefc40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BASIL-HART.jpg
// module id = +MnP
// module chunks = 0